import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-property-summary',
  templateUrl: './property-summary.component.html',
  styleUrls: ['./property-summary.component.scss']
})
export class PropertySummaryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
